var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#D7F3E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.6665C9.45455 16.6665 8.93346 16.4464 7.89129 16.0061C5.2971 14.9103 4 14.3624 4 13.4407C4 13.1826 4 8.70951 4 6.6665M10 16.6665C10.5455 16.6665 11.0665 16.4464 12.1087 16.0061C14.7029 14.9103 16 14.3624 16 13.4407V6.6665M10 16.6665L10 9.56973",
    stroke: "#138643",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55061 8.46084L5.60314 7.51848C4.53438 7.00132 4 6.74274 4 6.33325C4 5.92376 4.53438 5.66518 5.60314 5.14802L7.55061 4.20566C8.75256 3.62406 9.35353 3.33325 10 3.33325C10.6465 3.33325 11.2474 3.62406 12.4494 4.20566L14.3969 5.14802C15.4656 5.66518 16 5.92376 16 6.33325C16 6.74274 15.4656 7.00132 14.3969 7.51848L12.4494 8.46084C11.2474 9.04245 10.6465 9.33325 10 9.33325C9.35353 9.33325 8.75256 9.04245 7.55061 8.46084Z",
    stroke: "#138643",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10L7.33333 10.6667",
    stroke: "#138643",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 4.6665L6.66602 7.99984",
    stroke: "#138643",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrder);
export default __webpack_public_path__ + "static/media/icon-order.5c9bae490db543dbba89ef58872fe009.svg";
export { ForwardRef as ReactComponent };